<h4 mat-dialog-title>{{ 'INDEXDB.MEMORY_USAGE' | translate }}</h4>
<mat-dialog-content>
  @if (storageFacts$ | async; as storageFacts) {
    @if (storageFacts.temporaryOrdersCount > 0) {
      <div class="caption">{{ 'INDEXDB.TEMPORARY_ORDER_COUNT' | translate }}</div>
      <div class="info">{{ storageFacts.temporaryOrdersCount }}</div>
    }
    @if (storageFacts.offlineOrdersCount > 0) {
      <div class="caption">{{ 'INDEXDB.ORDER_COUNT' | translate }}</div>
      <div class="info">{{ storageFacts.offlineOrdersCount }}</div>
    }
    <div class="caption">{{ 'INDEXDB.USED_MEMORY' | translate }}</div>
    <div class="info">{{ storageFacts.usedSpace }}</div>
    <div class="caption">{{ 'INDEXDB.AVAILABLE_MEMORY' | translate }}</div>
    <div class="info">{{ storageFacts.availableSpace }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
